// Firebase configuration for frontend
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

// IMPORTANT: The authDomain must match the registered redirect URI in Google Console
// Registered redirect URI: https://esg-playbook-dev-415505.firebaseapp.com/__/auth/handler
// If you have VITE_FIREBASE_AUTH_DOMAIN set in .env, make sure it matches this value
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ,
  // Force correct auth domain to match registered redirect URI
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'product-hub-478006.firebaseapp.com', // Must match: https://esg-playbook-dev-415505.firebaseapp.com/__/auth/handler
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||'product-hub-478006.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '1008640724491',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:1008640724491:web:6d00a3025e37ba2166010e',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-DHBCD1B9GL'
};

// Initialize Firebase app (only if not already initialized)
let firebaseApp;
if (!getApps().length) {
  firebaseApp = initializeApp(firebaseConfig);
} else {
  firebaseApp = getApps()[0];
}

// Get auth instance
const auth = getAuth(firebaseApp);

// Set persistence to LOCAL to maintain session across browser sessions
// This ensures users stay logged in until they explicitly sign out
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set Firebase auth persistence:', error);
});

export { auth, firebaseConfig, firebaseApp };

